import * as React from "react"
import { useState, useEffect } from "react"
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  alpha,
} from "@mui/material"
import { useNavigate } from "react-router-dom"
import { downscale, dataURLToBlob } from "../../utils/imageFunctions"
import Camera from "react-html5-camera-photo"
import CameraAltIcon from "@mui/icons-material/CameraAlt"
import "react-html5-camera-photo/build/css/index.css"

function CameraTab() {
  const [image, setImage] = useState(null)
  const [selectedFile, setSelectedFile] = useState(null)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleTakePhoto = (dataUri) => {
    downscale(dataUri, 1024).then((resizedImage) => {
      setImage(resizedImage)
      const blob = dataURLToBlob(resizedImage)
      let extension = blob.type.split("/")[1]
      if (extension === "jpeg") {
        extension = "jpg"
      }
      const newFile = new File([blob], `camera-image.${extension}`, {
        type: blob.type,
      })
      setSelectedFile(newFile)
    })
  }

  const fetchClimb = async () => {
    if (selectedFile) {
      console.log(selectedFile)
      setLoading(true)
      const formData = new FormData()
      formData.append("image", selectedFile)

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL || ""}/api/find_climb`,
          {
            method: "POST",
            body: formData,
          }
        )
        const json = await response.json()
        const climbId = json.uuid
        console.info("climbId: ", climbId)
        navigate(`/climb/${climbId}`)
        console.info(json)
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    fetchClimb()
  }, [selectedFile])

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 3,
      }}
    >
      {/* Camera viewfinder */}
      <Card
        sx={{
          width: "100%",
          maxWidth: 640,
          overflow: "hidden",
          "& .react-html5-camera-photo": {
            "& video": {
              borderRadius: 1,
            },
          },
        }}
      >
        <Camera
          onTakePhoto={(dataUri) => handleTakePhoto(dataUri)}
          idealFacingMode="environment"
        />
      </Card>

      {/* Result area */}
      {(loading || image) && (
        <Card sx={{ width: "100%", maxWidth: 640 }}>
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              p: 3,
            }}
          >
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 2,
                  py: 4,
                }}
              >
                <CircularProgress size={48} />
                <Typography variant="body2" color="text.secondary">
                  Identifying climb...
                </Typography>
              </Box>
            ) : (
              image && (
                <Box
                  component="img"
                  src={image}
                  alt="Captured photo"
                  sx={{
                    width: "100%",
                    borderRadius: 1,
                    display: "block",
                  }}
                />
              )
            )}
          </CardContent>
        </Card>
      )}

      {/* Hint when no photo taken yet */}
      {!image && !loading && (
        <Box
          sx={(theme) => ({
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
            py: 3,
            color: "text.secondary",
          })}
        >
          <CameraAltIcon sx={{ fontSize: 40, opacity: 0.4 }} />
          <Typography variant="body2">
            Point at a climbing wall and take a photo
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default CameraTab
